module.exports = __webpack_public_path__ + "img/default-bg.c977624a.png";